// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3BXgc","list":"styles_list__2DffC"};